import { render, staticRenderFns } from "./VueTablePagination.vue?vue&type=template&id=4387e816&"
import script from "./VueTablePagination.vue?vue&type=script&lang=js&"
export * from "./VueTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports